import '@/globals/globals'
import { Part } from '@/types/part'
import { PartGroup } from '@/types/partGroup'
import { Box, Flex, Link, SimpleGrid, Stack, Text } from '@chakra-ui/react'

export const PartsList = (props: { partsList: PartGroup[] }) => {
  if (!props.partsList || props.partsList.length === 0) {
    return null
  }

  return (
    <SimpleGrid columns={{ base: 1, lg: 2 }}>
      {props.partsList.map((group: PartGroup) => (
        <Flex
          key={group.id}
          alignItems='flex-start'
          m={2}
          p={2}
          bg='gray.100'
          borderRadius='xl'>
          <Flex
            backgroundColor='gray.150'
            p={2}
            borderRadius='xl'
            flexDirection='column'
            gap={2}
            w='88px'>
            {group.icon ? (
              <img
                style={{
                  objectFit: 'contain',
                  objectPosition: 'center',
                  width: '100%',
                  height: '48px',
                }}
                src={group.icon}
                width='48'
                height='48'
                alt=''
              />
            ) : null}
            <Text
              fontSize='2xs'
              fontWeight='bold'
              textAlign='center'
              textTransform='uppercase'>
              {group.name}
            </Text>
          </Flex>
          <Stack ml={4} gap={1} p={2}>
            {group.parts &&
              group.parts.length > 0 &&
              group.parts.map((part: Part) => (
                <Box key={part.id}>
                  <div>
                    <Text as='div' fontWeight='bold' fontSize='lg' mb={1}>
                      {part.name}
                    </Text>
                    {part.number && (
                      <Text
                        as='div'
                        backgroundColor='gray.200'
                        borderRadius='base'
                        color='gray.600'
                        fontSize='2xs'
                        fontWeight='bold'
                        width='fit-content'
                        px={1.5}
                        py={0.5}>
                        {part.number}
                      </Text>
                    )}
                  </div>
                  {part.productUrl && (
                    <Link
                      fontSize='xs'
                      href={part.productUrl}
                      target='_blank'
                      rel='noreferrer nofollow noopener'>
                      visit product site ›
                    </Link>
                  )}
                </Box>
              ))}
          </Stack>
        </Flex>
      ))}
    </SimpleGrid>
  )
}
